export const delText = {
    fontFamily: 'Golos Text',
    fontSize: '23px',
    fontWeight: '500',
    lineHeight: '31.2px'

}